import { connect, Dispatch } from 'react-redux'
import FrontPage from '../pages/FrontPage'
import { IStoreState } from '../types/index'
import { getSnapshot } from '../ducks/snapshot'

const mapStateToProps = ({ snapshot, animationId, timer }: IStoreState) => ({
  snapshot,
})

const mapDispatchToProps = (dispatch: Dispatch) => ({
  getSnapshot(w: { view: number, request: { method: string; url: string } }) {
    dispatch(getSnapshot(w))
  }
})

export default connect(mapStateToProps, mapDispatchToProps)(FrontPage)



// WEBPACK FOOTER //
// ./src/containers/FrontPage.ts